import {AbstractNotificationComponent} from "../AbstractNotificationComponent";


export class EquityNotification extends AbstractNotificationComponent {

    static instance = ({
        template: require('./EquityNotification.html'),
        controller: ['$scope', '$location', EquityNotification],
        bindings: {
            notification: '<'
        }
    });
}